import { Form, GroupItem, SimpleItem } from "devextreme-react/form";
import { forwardRef } from "react";
import { useSelector } from "react-redux";
import { getLocalized } from "../../redux/localization";
import { renderInformationItem } from "../productRequestPage/detail";
import { AccountCallLogStatus } from "./type";

const AccountCallLogStatusDetail = forwardRef<any, { data: AccountCallLogStatus }>((
    { data }, ref
) => {
    const localize = useSelector(getLocalized);
    return <Form
        ref={ref}
        formData={data}
    >
        <GroupItem>
            <SimpleItem
                dataField={"Name"}
                label={{
                    text: localize.getString("name")
                }}
                render={renderInformationItem}
            >

            </SimpleItem>
            <SimpleItem
                dataField={"Description"}
                label={{
                    text: localize.getString("description")
                }}
                render={renderInformationItem}
            >

            </SimpleItem>
        </GroupItem>
    </Form>
})

export default AccountCallLogStatusDetail;